import { WidgetsReportsMain } from '@/widgets/reports';

export const PagesReportsPhotoMain = () => <WidgetsReportsMain type="PHOTO" />;
